import { propClassName } from '@/styles/AuthorDetails';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn, withNonHTMLChildren, withSafeInnerHTML } from 'lib/utils';
import { useAuthorDetailsContext } from './AuthorDetails';

export interface AuthorDetailsHeadlineProps extends ComponentProps<'h1'> {
  colors?: ClassNameProp<'default' | 'alternative'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  variant?: ClassNameProp<'default' | 'alternative'>;
}

export const AuthorDetailsHeadlineComponent: Component<AuthorDetailsHeadlineProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const context = useAuthorDetailsContext({ colors, size, variant });

  const colorsClassName = propClassName('headline_colors', context.colors ?? context.variant);
  const sizeClassName = propClassName('headline_size', context.size ?? context.variant);
  const variantClassName = propClassName('headline_variant', context.variant);

  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <h1 className={componentClassName} {...withSafeInnerHTML(children)} {...props}>
      {withNonHTMLChildren(children)}
    </h1>
  );
};
